export default "__VITE_ASSET__CYh5CSLH__"